export default "__VITE_ASSET__WLnxWUSu__"